import { render, staticRenderFns } from "./EditStempelantrag.vue?vue&type=template&id=1fee1cfc&scoped=true"
import script from "./EditStempelantrag.vue?vue&type=script&lang=ts"
export * from "./EditStempelantrag.vue?vue&type=script&lang=ts"
import style0 from "./EditStempelantrag.vue?vue&type=style&index=0&id=1fee1cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fee1cfc",
  null
  
)

export default component.exports